// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const MicrosoftIcon = createSvgIcon(
  <svg fill="currentColor" viewBox="0 0 448 512">
    <path d="M0 32h214.6v214.6H0zm233.4 0H448v214.6H233.4zM0 265.4h214.6V480H0zm233.4 0H448V480H233.4z" />
  </svg>,
  "Microsoft",
);
export default MicrosoftIcon;
